const items = [
  {
    id: 1,
    tag: '独家爆料',
    title: '2025娱乐圈大地震：多位顶流卷入税务风波，官方调查正在进行中',
    desc: '据知情人士透露，本次涉案金额巨大，涉及多名一线艺人及相关经纪公司，事件持续发酵中。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20editorial%20illustration%20with%20warm%20coral%20red%20and%20deep%20charcoal%20tones%2C%20breaking%20news%20visual%20style%2C%20dynamic%20geometric%20composition%2C%20dramatic%20lighting%2C%20magazine%20feature%20spread%20aesthetic%2C%20bold%20contrast%2C%20no%20text%2C%20sophisticated%20art%20direction&width=800&height=500&seq=carousel-1-chigua&orientation=landscape',
  },
  {
    id: 2,
    tag: '深度追踪',
    title: '网红圈黑幕大起底：MCN机构霸王条款曝光，头部主播集体维权',
    desc: '多位百万粉丝网红公开控诉MCN压榨行为，合同陷阱、分成不公等问题引发行业震动。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20editorial%20collage%20with%20warm%20amber%20and%20cream%20accents%2C%20investigative%20journalism%20visual%20theme%2C%20layered%20geometric%20abstract%20shapes%2C%20dramatic%20contrast%2C%20magazine%20layout%20style%2C%20no%20text%2C%20bold%20aesthetic&width=800&height=500&seq=carousel-2-chigua&orientation=landscape',
  },
  {
    id: 3,
    tag: '热门追踪',
    title: '某知名综艺节目录制现场突发状况，嘉宾当场翻脸离场引全网热议',
    desc: '节目组紧急叫停录制，制片方至今未回应事件缘由，网友扒出多段过往恩怨引发连锁讨论。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20visual%20with%20warm%20red%20and%20gold%20gradients%2C%20entertainment%20drama%20theme%2C%20bold%20geometric%20patterns%2C%20television%20studio%20inspired%20abstract%20composition%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20no%20text&width=800&height=500&seq=carousel-3-chigua&orientation=landscape',
  },
  {
    id: 4,
    tag: '独家解析',
    title: '娱乐圈资本局：2025年上半年影视投资大盘点，谁在抄底谁在撤退',
    desc: '从投资数据看行业风向，腾讯视频、爱奇艺、优酷三大平台的内容策略正在发生根本性转变。',
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20abstract%20business%20and%20entertainment%20fusion%20visual%2C%20warm%20coral%20tones%20with%20cream%20background%2C%20data%20visualization%20inspired%20geometric%20shapes%2C%20magazine%20editorial%20style%2C%20clean%20modern%20aesthetic%2C%20no%20text&width=800&height=500&seq=carousel-4-chigua&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">焦点专题</h2>
          <p className="text-foreground-500 text-sm">本周最受关注的爆料专题，深度追踪热门事件</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {items.map((item) => (
            <a
              key={item.id}
              href="#carousel"
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}